export default __webpack_public_path__ + "static/media/medical-history.028459ed.png";